module.exports = __webpack_public_path__ + "media/images/prizes__daily-982b4505b0b9f7b9b9a2297c1e603af2.png";